//
//  time.ts
//
//  isana.net,inc. Proprietary and Confidential
//

import dayjs from "dayjs";

export const DATE_STRING_FORMAT = "YYYY-MM-DD";

export const checkDateStringFormat = (dateString: string): boolean => {
  return dayjs(dateString, DATE_STRING_FORMAT).isValid();
};
